import App from './App'
import utils from "@/utils/index.js"
import i18n from './locale/index.js';
import noSpace from "@/directives/noSpace.js";
// #ifdef H5
import AsyncLoading from '@/components/async-loading/async-loading.vue';
import AsyncError from '@/components/async-error/async-error.vue';
// #endif

// #ifndef VUE3
import Vue from 'vue'
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
    ...App,
	i18n
})
app.$mount()
// #endif

// #ifdef VUE3
import { createSSRApp } from 'vue'
import * as Pinia from 'pinia';
import { pinia } from '@/stores/pinia.js';

export function createApp() {
  const app = createSSRApp(App);
  app.use(pinia);
  app.use(utils);
  app.use(i18n);
  app.directive('no-space', noSpace);
  // #ifdef H5
  app.component('AsyncLoading', AsyncLoading);
  app.component('AsyncError', AsyncError);
  // #endif
  return {
    app,
	Pinia
  }
}
// #endif